import React from 'react' ;

function Button(props) {
    const { onClick } = props ;

    return (
        <button onClick = {onClick}>Add Data</button>
    ) ;
}

export default Button ;